export const SET_PRODUCTS = 'SET_PRODUCTS';
export const setProducts = data => ({ type: SET_PRODUCTS, data });

export const CHECK_IF_EAN_ALREADY_PRESENT = 'CHECK_IF_EAN_ALREADY_PRESENT';
export const checkIfEanAlreadyPresent = data => ({
  type: CHECK_IF_EAN_ALREADY_PRESENT,
  payload: data
});

export const ADD_PRODUCTS_ERRORS = 'ADD_PRODUCTS_ERRORS';
export const addProductsErrors = data => ({
  type: ADD_PRODUCTS_ERRORS,
  payload: data
});

export const ADD_PRODUCTS_WARNING = 'ADD_PRODUCTS_WARNING';
export const addProductsWarning = data => ({
  type: ADD_PRODUCTS_WARNING,
  payload: data
});

export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const deleteProduct = data => ({ type: DELETE_PRODUCT, data });

export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const editProduct = (data, indx) => ({
  type: DELETE_PRODUCT,
  payload: data,
  index: indx
});

export const OPEN_REVIEW_PRODUCT_DIALOG = 'OPEN_REVIEW_PRODUCT_DIALOG';
export const openReviewProductDialog = (data, index) => ({
  type: OPEN_REVIEW_PRODUCT_DIALOG,
  payload: data,
  index
});

export const CLOSE_REVIEW_PRODUCT_DIALOG = 'CLOSE_REVIEW_PRODUCT_DIALOG';
export const closeReviewProductDialog = data => ({
  type: CLOSE_REVIEW_PRODUCT_DIALOG,
  payload: data
});

export const OPEN_DELETE_PRODUCT_DIALOG = 'OPEN_DELETE_PRODUCT_DIALOG';
export const openDeleteProductDialog = (data, index) => ({
  type: OPEN_DELETE_PRODUCT_DIALOG,
  payload: data,
  index
});

export const CLOSE_DELETE_PRODUCT_DIALOG = 'CLOSE_DELETE_PRODUCT_DIALOG';
export const closeDeleteProductDialog = data => ({
  type: CLOSE_DELETE_PRODUCT_DIALOG,
  payload: data
});

export const SET_PRODUCTS_ARE_IN_STOCK = 'SET_PRODUCT_ARE_IN_STOCK';
export const setProductsAreInStock = data => ({
  type: SET_PRODUCTS_ARE_IN_STOCK,
  data
});

export const CREATE_STOCK_BATCH = 'CREATE_STOCK_BATCH';
export const CREATE_STOCK_BATCH_SUCCESS = 'CREATE_STOCK_BATCH_SUCCESS';
export const createStockBatch = commands => ({
  type: CREATE_STOCK_BATCH,
  payload: commands
});

export const RESET_IMPORT_PRODUCTS = 'RESET_IMPORT_PRODUCTS';
export const resetImportProducts = () => ({ type: RESET_IMPORT_PRODUCTS });

export const GET_REQUIRED_ATTRIBUTES = 'GET_REQUIRED_ATTRIBUTES';
export const GET_REQUIRED_ATTRIBUTES_SUCCESS =
  'GET_REQUIRED_ATTRIBUTES_SUCCESS';
export const GET_REQUIRED_ATTRIBUTES_FAILURE =
  'GET_REQUIRED_ATTRIBUTES_FAILURE';

export const getRequiredAttributes = () => ({ type: GET_REQUIRED_ATTRIBUTES });

export const GET_BARCODE_VALUES = 'GET_BARCODE_VALUES';
export const GET_BARCODE_VALUES_SUCCESS = 'GET_BARCODE_VALUES_SUCCESS';
export const GET_BARCODE_VALUES_FAILURE = 'GET_BARCODE_VALUES_FAILURE';

export const getBarcodeValues = () => ({ type: GET_BARCODE_VALUES });

export const HANDLE_LOADER = 'HANDLE_LOADER';
